import { getData, putData } from '../plugins/ApiCalls'

export function getPhishingRules(etag = null) {
  const headers = {}
  if (etag) {
    headers['If-None-Match'] = etag
  }

  return getData('security/phishing-rules', {
    headers,
    validateStatus: (status) => (status >= 200 && status < 300) || status === 304
  })
}

export function getPhishingReviews(params = {}) {
  const queryParams = Object.entries(params).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      acc[key] = value
    }
    return acc
  }, {})

  return getData('security/phishing-reviews', { params: queryParams })
}

export function approvePhishingReview(id, notes = '') {
  return putData(`security/phishing-reviews/${id}/status`, { status: 'approved', notes }, { emulateJSON: true })
}

export function suspendPhishingReview(id, notes = '') {
  return putData(`security/phishing-reviews/${id}/status`, { status: 'suspended', notes }, { emulateJSON: true })
}
